import { useEffect, useState } from "react";

export const useHideEmailSuggestionOnScroll = (targetElementId: string) => {
  const [hideSuggestion, setHideSuggestion] = useState<boolean>(false);

  const drawerEl = document.querySelector(".MuiDrawer-paper");

  useEffect(() => {
    const handleHideSuggestion = () => {
      const emailInputHeightTop = document
        .querySelector(`#${targetElementId}`)
        ?.getBoundingClientRect().top;
      const emailInputHeightBottom = document
        .querySelector(`#${targetElementId}`)
        ?.getBoundingClientRect().bottom;
      const drawerHeight = drawerEl?.getBoundingClientRect().top;

      const hideOrNot =
        !!emailInputHeightTop &&
        !!emailInputHeightBottom &&
        !!drawerHeight &&
        (emailInputHeightTop < drawerHeight ||
          emailInputHeightBottom + drawerHeight + 16 >
            window.visualViewport!.height);

      return setHideSuggestion(hideOrNot);
    };

    drawerEl?.addEventListener("scroll", handleHideSuggestion);

    handleHideSuggestion();

    return () => drawerEl?.removeEventListener("scroll", handleHideSuggestion);
  }, [drawerEl, targetElementId]);

  return { hideSuggestion };
};
